module.exports = __webpack_public_path__ + "img/ai_loading.8046e17d.png";